import { FancyRadio } from 'apps/builder/components/settings/modal'
import { SettingsFieldSelect } from 'apps/builder/components/settings/modal/shared'
import { useDispatch, useSelector } from 'react-redux'
import { Input } from 'components/Input/Input'
import { updateEntry } from 'apps/builder/store/actions/entries'
import { whiteLabelSelector } from 'apps/builder/store/selectors'

export const DEFAULT_URL = 'https://www.gocanvas.com'
export const NON_BRANDED_URL = 'https://www.example.com'

const genereateSafeDefaultValue = defaultValue => {
  if (defaultValue && !defaultValue.includes('gocanvas')) {
    return defaultValue
  }
  
  return NON_BRANDED_URL
}

export const LinkField = ({
  guid,
  label,
  default: defaultValue,
  type,
  mask,
  style,
  keyField,
}) => {
  const dispatch = useDispatch()
  const isWhiteLabeled = useSelector(whiteLabelSelector)
  const safeDefaultValue = isWhiteLabeled ? genereateSafeDefaultValue(defaultValue) : defaultValue 
  
  const updateDefaultValue = value => {
    dispatch(
      updateEntry({
        guid,
        default: value,
      })
    )
  }

  /** Mask is the button text */
  const updateMask = value => {
    dispatch(
      updateEntry({
        guid,
        mask: value,
      })
    )
  }

  const inputProps = {
    value: safeDefaultValue,
    error: false,
    update: updateDefaultValue,
    additionalClass: 'settings--inputs',
    label: 'URL',
  }

  const onSaveFormat = style => {
    const format = {
      0: 'Button',
      1: 'Link',
    }
    return format[style]
  }

  const linkStyle = onSaveFormat(style)

  return (
    <>
      <div className="settings--row">
        <SettingsFieldSelect
          guid={guid}
          label={label}
          keyField={keyField}
          type={type}
        />
      </div>

      <div className="settings--format--wrapper">
        <label className="settings--label">Style</label>
        <FancyRadio
          id={`${guid}-1`}
          label={'Button'}
          selected={linkStyle || 'Button'}
          value={'Button'}
          onChange={(checked, value) => {
            checked
              ? dispatch(
                  updateEntry({
                    guid,
                    style: 0,
                  })
                )
              : ''
          }}
        />
        <FancyRadio
          id={`${guid}-2`}
          label={'Link'}
          selected={linkStyle || 'Button'}
          value={'Link'}
          onChange={(checked, value) => {
            checked
              ? dispatch(
                  updateEntry({
                    guid,
                    style: 1,
                  })
                )
              : ''
          }}
        />
      </div>

      <div className="settings--link">
        <Input id={`url-input-${guid}`} {...inputProps} />
      </div>
      {linkStyle == 'Button' ? (
        <div className="settings--link">
          <Input
            id={`button-label-input-${guid}`}
            maxLength={30}
            value={mask || ''}
            update={updateMask}
            label="Button Label"
          />
        </div>
      ) : (
        ''
      )}
    </>
  )
}
